"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuditStatus;
(function (AuditStatus) {
    AuditStatus["all"] = "all";
    AuditStatus["aud"] = "aud";
    AuditStatus["carrier"] = "car";
    AuditStatus["client"] = "cli";
    AuditStatus["sti"] = "sti";
})(AuditStatus = exports.AuditStatus || (exports.AuditStatus = {}));
//# sourceMappingURL=AuditStatus.js.map